module.exports = __webpack_public_path__ + "static/img/bg-en.3109b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-en.png
// module id = tK4J
// module chunks = 1